<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-input v-model="lb_value" placeholder="请输入内容" size="small"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="title" label="攻略标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sort" label="排序"></el-table-column>
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip>
					<template slot-scope="scope">
						{{date('Y-m-d H:i:s',scope.row.create_time)}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="展示设置" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题" prop='lb_title'>
						<el-input v-model="ruleForm.lb_title" size="small"></el-input>
					</el-form-item>
					<el-form-item label="封面" required>
						<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
							:headers="{ token:$store.state.user.token }"
							:data="{ image_class_id:'72',file_type:'1' }" :limit="1"
							:file-list="ruleForm.fm_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
							list-type="picture-card">
							<i class="el-icon-plus"></i>
							<!-- verification:1,fileS:2,fileH:300,fileW:300  -->
						</el-upload>
					</el-form-item>
					<el-form-item label="内容" prop='lb_content'>
						<tinymce ref="editor" v-model="ruleForm.lb_content"
							toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
					</el-form-item>
					<el-form-item label="排序" prop='lb_sort'>
						<el-input v-model="ruleForm.lb_sort" size="small" type="number"> </el-input>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			tinymce,
			comment
		},
		data() {
			return {
				lb_value: '',
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '',
				dialogVisible: false,
				subloading: false,

				ruleForm: {
					lb_title: '',
					lb_value: '',
					lb_content: '',
					lb_sort: 50,
					lb_dstime: '',
					lb_mapList: [],
					keyword: '',
					lb_state: '',
					ry_value: '',
					lb_dz: '',
					lb_ll: '',
					lb_sc: '',
					fm_mapList: [],
				},
				mapListed: [],
				state_options: [],
				ry_options: [],
				rule: {
					lb_value: [{
						required: true,
						message: '请填写图文类别',
						trigger: 'blur'
					}],
					lb_title: [{
						required: true,
						message: '请填写图文标题',
						trigger: 'blur'
					}],

					lb_content: [{
						required: true,
						message: '请填写图文内容',
						trigger: 'blur'
					}],
					lb_sort: [{
						required: true,
						message: '请填写排序',
						trigger: 'blur'
					}],
				},
				// 
				dialog_prev: false,
				urls: '',
				// 
				dialogs: false,
				date: xaoi.date,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 220 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 220 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			async search() {
				let that = this
				that.tableData = []
				that.loading = true
				let res = await this.ajax('tools/strategy/get', {
					page: that.currentPage,
					limit: that.pagesize,
					sousuo: that.lb_value,
				})
				if (res.code == 200) {
					that.loading = false
					that.tableData = res.data.data
					that.count = res.data.count
				}
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				that.dialogVisible = true
				that.eid = ''
				that.form_clear()
			},
			form_clear() {
				let that = this
				that.ruleForm.lb_title = ''
				that.ruleForm.lb_content = ''
				that.ruleForm.lb_sort = 50
				this.ruleForm.fm_mapList=[]
				this.mapListed=[]
			},

			async submit(formName) {
				let that = this
				that.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (this.mapListed.length==0) return this.$message.error('请上传封面')
						that.subloading = true
						let params = {
							id: that.eid,
							title: that.ruleForm.lb_title,
							content: that.ruleForm.lb_content,
							sort: that.ruleForm.lb_sort,
							file_info:this.mapListed,
						}
						let res = await this.ajax('tools/strategy/edit', params)
						if (res.code == 200) {
							that.subloading = false
							that.dialogVisible = false
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							that.search()
						} else {
							that.$message.error(response.data.msg);
							that.subloading = false
						}

					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.id
				that.ruleForm.lb_title = row.title
				that.ruleForm.lb_content = row.body
				that.ruleForm.lb_sort = row.sort

				this.ruleForm.fm_mapList=row.file_info
				this.mapListed=row.file_info
			},
			// 删除
			async handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let res = await this.ajax('tools/strategy/del', {
						id: row.id
					})
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						that.search()
					} else {
						that.$message.error(res.data.msg);
					}

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
		
			goprev(item) {
				let that = this
				that.dialog_prev = true
				that.urls = item.url
			},
			// 
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},
		},
		watch: {
			
		}

	};
</script>


<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tablimg {
		margin: 2px 5px;
	}

	.con_b {
		height: 500px;
		overflow-x: auto;
		border: 1px solid rgb(206, 206, 206);
		border-radius: 5px;
	}
</style>